import React from "react";
import {
    GradeRuleModelType,
    jsonRegex,
    OtherRulesItem,
    queryGradeRuleItem,
    SelectMap,
    SignMap
} from "../../../../../../API/scoreRule";
import style from "./index.module.scss";
import useDeviceType from "Utils/useDeviceType";

interface FormulaModeColumnProps {
    isShow: boolean; //是否有json数据
    value: string; //当前项数据
    record: GradeRuleModelType; //当前行数据
    styles?: React.CSSProperties;
    fontStyle?: React.CSSProperties;
}
const Index = ({
    value,
    isShow,
    record,
    styles,
    fontStyle
}: FormulaModeColumnProps) => {
    const { isPC } = useDeviceType();
    if (!jsonRegex.test(value)) {
        return <span>{value}</span>;
    }
    const title =
        record.flag && SelectMap[record.flag]?.title[record.description];
    const rulesObj = isShow && JSON.parse(value);

    const render = (
        <>
            {rulesObj?.otherRules && rulesObj.otherRules.length !== 0 && (
                <div>高级设置：</div>
            )}

            {record.flag === "SignInCalculator" && (
                <div style={fontStyle}>
                    正常出勤记出勤 {rulesObj?.done} 次。请假记出勤
                    {rulesObj?.leave}
                    次。迟到、早退记出勤 {rulesObj?.late} 次。
                </div>
            )}
            {rulesObj?.otherRules?.map(
                (item: OtherRulesItem, index: number) => (
                    <div className={style.row} style={styles} key={index}>
                        {item.rangeVal1}
                        {SignMap[item.sign1]}
                        {title}
                        {SignMap[item.sign2]}
                        {item.rangeVal2}
                        成绩：
                        {item.grade}
                    </div>
                )
            )}

            {rulesObj?.detailWeight && rulesObj.detailWeight.length !== 0 && (
                <span className={!isPC ? style.mobile : ""}>明细分配：</span>
            )}

            {rulesObj?.detailWeight
                ?.filter((item: queryGradeRuleItem) => !!item.weight)
                .map((item: queryGradeRuleItem, index: number) => (
                    <div className={style.detail} style={styles} key={index}>
                        <span>{item.name}</span>
                        &nbsp;&nbsp;
                        <span>{item.weight}%;</span>&nbsp;&nbsp;
                    </div>
                ))}
        </>
    );

    return <>{render}</>;
};

export default Index;
